import React from "react";
import HeaderOne from "./HeaderOne";
import FooterOne from "./FooterOne";

const TermOfUse = () => {
  document.title = "Terms of Use | MordenBazaar";

  return (
    <>
      <HeaderOne />

      <div className="page-content pt-0">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-9 col-xl-8">

              <h1 className="mt-4 mb-4">Terms of Use</h1>

              {/* INTRO */}
              <ul className="list-disc pl-5 mb-5 space-y-2">
                <li>By accessing or using MordenBazaar, you agree to these Terms of Use.</li>
                <li>Please read these terms carefully before using the platform.</li>
                <li>If you do not agree with any part of these terms, you should discontinue use.</li>
              </ul>

              {/* 1 */}
              <h2 className="mt-5 mb-3">1. Eligibility</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>You must be at least 18 years old to use MordenBazaar.</li>
                <li>Users below 18 may access the platform only under parental supervision.</li>
                <li>Accounts violating this requirement may be suspended or terminated.</li>
              </ul>

              {/* 2 */}
              <h2 className="mt-5 mb-3">2. Account Security & Accuracy</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
                <li>All information provided during registration must be accurate and up to date.</li>
                <li>Providing false or misleading information may result in account termination.</li>
              </ul>

              {/* 3 */}
              <h2 className="mt-5 mb-3">3. Communications</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>You agree to receive transactional communications related to your orders.</li>
                <li>You may receive promotional messages via email, SMS, or WhatsApp.</li>
                <li>You can opt out of promotional communications at any time.</li>
              </ul>

              {/* 4 */}
              <h2 className="mt-5 mb-3">4. Use of Platform & Content Policy</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>The platform must be used only for lawful and personal purposes.</li>
                <li>Uploading unlawful, offensive, misleading, or fraudulent content is prohibited.</li>
                <li>All text, images, logos, designs, and content are protected by copyright.</li>
                <li>Unauthorized use or reproduction of content is not allowed.</li>
                <li>MordenBazaar may remove content or suspend accounts violating these rules.</li>
              </ul>

              {/* 5 */}
              <h2 className="mt-5 mb-3">5. Products & Sales</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Products listed on MordenBazaar are sold directly by the platform.</li>
                <li>Product pricing, availability, and details may change without prior notice.</li>
                <li>Some products may have additional terms mentioned on their pages.</li>
              </ul>

              {/* 6 */}
              <h2 className="mt-5 mb-3">6. Orders, Payments & Pricing</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>All orders must be paid in Indian Rupees using available payment methods.</li>
                <li>Cash on Delivery may be available for select locations.</li>
                <li>Orders may be cancelled due to payment failure, technical issues, or suspected fraud.</li>
                <li>Shipping charges and free-shipping limits apply as per Shipping Policy.</li>
              </ul>

              {/* 7 */}
              <h2 className="mt-5 mb-3">7. Loyalty, Referral & Promotional Programs</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>MordenBazaar may introduce loyalty, referral, or promotional programs.</li>
                <li>Each program will have separate eligibility criteria and rules.</li>
                <li>Programs may be modified or discontinued without notice.</li>
              </ul>

              {/* 8 */}
              <h2 className="mt-5 mb-3">8. Intellectual Property Rights</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>All trademarks, designs, and content belong exclusively to MordenBazaar.</li>
                <li>Unauthorized use, copying, or reproduction is strictly prohibited.</li>
              </ul>

              {/* 9 */}
              <h2 className="mt-5 mb-3">9. Disclaimer & Limitation of Liability</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>The platform is provided on an “as is” basis without warranties.</li>
                <li>MordenBazaar is not liable for indirect or consequential damages.</li>
                <li>Order-related disputes are governed by Cancellation & Return Policies.</li>
              </ul>

              {/* 10 */}
              <h2 className="mt-5 mb-3">10. Governing Law</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>These Terms are governed by the laws of India.</li>
                <li>All disputes shall be subject to courts in <strong>Satna, Madhya Pradesh</strong>.</li>
              </ul>

              {/* 11 */}
              <h2 className="mt-5 mb-3">11. Updates to Terms</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>MordenBazaar may update these Terms at any time.</li>
                <li>Continued use of the platform indicates acceptance of updated Terms.</li>
              </ul>

              {/* 12 */}
              <h2 className="mt-5 mb-3">12. User Conduct & Account Termination</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Users must not misuse, hack, or interfere with platform functionality.</li>
                <li>Accounts involved in violations or suspicious activities may be terminated.</li>
              </ul>

              {/* 13 */}
              <h2 className="mt-5 mb-3">13. Contact & Grievance Officer</h2>
              <ul className="list-disc pl-5 mb-5 space-y-2">
                <li><strong>Email:</strong> support@mordenbazaar.com</li>
                {/* <li><strong>Grievance Officer:</strong> [Name]</li>
                <li><strong>Address:</strong> [Business Address]</li> */}
              </ul>

            </div>
          </div>
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default TermOfUse;